// @flow

import { createContext, useContext } from 'react';
import { type PublicIntegrationKey } from './public-integration-key';

const PublicIntegrationKeyContext = createContext<?PublicIntegrationKey>(null);

export const PublicIntegrationKeyProvider = PublicIntegrationKeyContext.Provider;

export function usePublicIntegrationKey(): PublicIntegrationKey {
  const context = useContext(PublicIntegrationKeyContext);
  if (!context) {
    throw new Error('Public integration key not provided');
  }
  return context;
}
